<template>
  <div class="comp-wrapper">
		<a :href="'../competition/'+movies[0].competition[0].slug" class="comp-title">
			<h1>{{compName}}</h1>
			<span>
				{{ lang=='he-IL'? '(#) לכל סרטי המסגרת ':'(#) To all competition movies' }}
			</span>
		</a>
		<div class="comp-strip-arrows-wrapper">
			<div class="right-arrow" @click="scrollStrip($event, lang=='he-IL'? 1:-1)" :class="{ 'hidden-arrow': !hasRightArrow }"
				:style="{ 'right': lang=='he-IL'? '0':'unset', 'left': lang=='he-IL'? 'unset':'0' }">❮</div>
			<div class="left-arrow" @click="scrollStrip($event, lang=='he-IL'? -1:1)" :class="{ 'hidden-arrow': !hasLeftArrow }"
				:style="{ 'right': lang=='he-IL'? 'unset':'0', 'left': lang=='he-IL'? '0':'unset' }">❯</div>
		</div>
		<div class="comp-strip">
			<!-- AppDisplayPost Component -->
			<app-display-post
				v-for="movie in movies"
				:key="movie.id"
				:search-term="searchTerm"
				:movie="movie"
				role="article" >
				<!-- AppDisplayPost is called for each post in the filteredResults -->
			</app-display-post>
		</div>
  </div>
</template>

<script>
import AppDisplayPost from './AppDisplayPost.vue';

export default {
	components: {
		'app-display-post': AppDisplayPost
	},
	data() {
		return {
			searchTerm: '',
			hasRightArrow: false,
			hasLeftArrow: true,
			lang: 'he-IL'
		};
	},
	props: {
		compName: {
			type: String,
			required: true,
			default: ''
		},
		movies: {
			type: Array,
			required: true,
			default: []
		}
	},
	methods: {
		scrollStrip(e, offset) {
			let stripElm = e.target.parentNode.parentNode.querySelector(".comp-strip") 
			let speed = 300
			stripElm.scrollBy({
				top: 0,
				left: offset*speed,
				behavior: 'smooth'
			})
			setTimeout(_=> {
				if (this.lang=='he-IL') {
					this.hasRightArrow = stripElm.scrollLeft < 0;
					this.hasLeftArrow = stripElm.scrollLeft+stripElm.scrollWidth > stripElm.offsetWidth;
				} else {
					this.hasRightArrow = stripElm.scrollLeft > 0;
					this.hasLeftArrow = stripElm.scrollLeft < stripElm.scrollWidth - stripElm.offsetWidth;
				}
			}, 500)
		}
	},
	mounted() {
		this.lang = document.getElementsByTagName('html')[0].getAttribute('lang')
	}
};
</script>

<style scoped>

.comp-wrapper {
	width: 100%;
}

.comp-strip {
	display: flex;
	gap: 10px;
	overflow-x: scroll;
	padding-block: 10px;
    -ms-overflow-style: none;  /* Internet Explorer 10+ */
    scrollbar-width: none;  /* Firefox */
}
.comp-strip::-webkit-scrollbar {
    display: none;  /* Safari and Chrome */
}

.comp-strip-arrows-wrapper  {
	position: relative;
	top: 25%;
}
.comp-strip-arrows-wrapper [class$="arrow"] {
	position: absolute;
	color: var(--pink);
	z-index: 2;
	font-size: 5em;
	padding: 5px 0;
	cursor: pointer;
	top: 0;
	opacity: 1;
	transition: 300ms ease-in-out;
}

.comp-strip-arrows-wrapper .hidden-arrow {
	top: 200%;
	opacity: 0;
	pointer-events: none;
}

.comp-title {
	overflow: hidden;
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 6px;
	cursor: pointer;
  width: fit-content;
}

.comp-title h1 {
	width: fit-content;
	margin: 0;
	padding: 0;
}

.comp-title span {
	opacity: 0;
	position: relative;
	top: 100%;
	transition: 300ms ease-in-out;
}

.comp-title:hover span {
	opacity: 1;
	top: 0;
}

@media only screen and (max-width: 768px) {
	.comp-wrapper {
		position: relative;
	}
	.comp-title {
		flex-direction: column;
    align-items: baseline;
	}

	.comp-title span {
		opacity: 1;
	}

	.comp-strip-arrows-wrapper  {
		position: absolute;
		top: 53%;
		width: 110%;
		right: -5%;
	}
}

</style>
